<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand asm-brand" [routerLink]="'/'" aria-label="ASM Global Trading FZE home">
            <img src="assets/images/logo.jpeg" alt="ASM Global Trading FZE">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('home')">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('features')">Capabilities</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('team')">Leadership</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('services')">Services</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('about')">Portfolio</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('portfolio')">Brands</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('pricings')">Programs</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('blog')">Network</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('contact')">Contact</a>
                </li>
            </ul>
            <div class="nav-button ms-auto xs-ml-0 xs-mt-20"><ul class="nav navbar-nav navbar-right"><li><a class="btn btn-lg btn-gradient-primary btn-circle" href="https://store.asmglobaltrading.com/" target="_blank" rel="noopener">Online Store</a></li></ul></div>
        </div>

    </div>
</nav>
